import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { Menu, X } from 'lucide-react'

export default function Header() {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)

  return (
    <header className="relative z-50 bg-terminal-bg/95 backdrop-blur-sm">
      {/* Desktop — slim text nav */}
      <nav className="hidden md:flex items-center justify-center gap-10 py-4 px-6">
        <NavItem to="/"           label="HOME"       active={pathname === '/'} />
        <NavItem to="/operations" label="OPERATIONS" active={pathname === '/operations'} />
        <NavItem to="/exploits"   label="EXPLOITS"   active={pathname === '/exploits'} />
        <NavItem to="/comms"      label="COMMS"      active={pathname === '/comms'} />
        <NavItem to="/about"      label="JOIN US"    active={pathname === '/about'} />
      </nav>

      {/* Mobile */}
      <div className="md:hidden flex items-center justify-between px-4 py-4">
        <Link to="/">
          <img src="/assets/teddy-kgb-logo.png" alt="Teddy-KGB" className="h-10 w-auto" />
        </Link>
        <button onClick={() => setOpen(!open)} className="text-text-gray hover:text-kgb-red transition-colors">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border-gray/30 px-4 pb-4 pt-3 space-y-3">
          {['/', '/operations', '/exploits', '/comms', '/about'].map((path, i) => (
            <Link
              key={path}
              to={path}
              onClick={() => setOpen(false)}
              className="block font-mono text-sm uppercase tracking-widest text-text-gray hover:text-kgb-red transition-colors py-1"
            >
              {['HOME', 'OPERATIONS', 'EXPLOITS', 'COMMS', 'JOIN US'][i]}
            </Link>
          ))}
        </div>
      )}
    </header>
  )
}

function NavItem({ to, label, active }: { to: string; label: string; active: boolean }) {
  return (
    <Link
      to={to}
      className={`font-mono text-sm uppercase tracking-widest transition-colors duration-150 ${
        active ? 'text-kgb-red' : 'text-text-gray hover:text-white'
      }`}
    >
      {label}
    </Link>
  )
}
